/*
 * @fileOverView Alert component definition
 */

import Vue from 'vue';

/**
 * Alert Vue
 * @type {class}
 */
Vue.component('alert-vue', {
  props: {
    'setMessage': {
      'type': String,
      'default': ''
    }
  },

  data: function() {
    return {
      isRemoved: false
    }
  },

  watch: {
    // Only want to expose setMessage to allow runtime message handling,
    // without refactoring current server side functionality.
    setMessage: function (val) {
      this.$refs.message.innerHTML = val;
    }
  }
});
